// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { UserServiceRequest } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Service/User';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

const useUserServiceRequests: () => UseQueryResult<
  TemplateContract<UserServiceRequest>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data;

  return useQueryWithOptions({
    queryKey: ['queryCollateralUserServiceRequests', operator],
    enabled: !!operator,
    select: (data: TemplateContract<UserServiceRequest>[]) =>
      data.filter((d) => d.payload.operator === operator),
    queryFn: async (_, options) => {
      if (!operator) {
        return Promise.resolve([]);
      }
      return ledgerApi.query(options, UserServiceRequest);
    },
  });
};

export default useUserServiceRequests;
